export class DataClassesDetails {
    'dataClasses';
    'eonDataClassifications';
    'isOverridden';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<DataClass>",
            "format": ""
        },
        {
            "name": "eonDataClassifications",
            "baseName": "eonDataClassifications",
            "type": "Array<DataClass>",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataClassesDetails.attributeTypeMap;
    }
    constructor() {
    }
}
